"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginRequest = exports.msalConfig = void 0;
const AUTH_CLIENT = window.AUTH_CLIENT || '';
const AUTH_REDIRECT_URI = window.AUTH_REDIRECT_URI || 'http://localhost:8080/';
const AUTH_AUTHORITY = window.AUTH_AUTHORITY || '';
const AUTH_SCOPE = `api://${AUTH_CLIENT}/fullAccess`;
exports.msalConfig = {
    auth: {
        clientId: AUTH_CLIENT, // APP id
        redirectUri: AUTH_REDIRECT_URI,
        authority: AUTH_AUTHORITY, // 'https://login.microsoftonline.com/{AUTH_CLIENT}',
    },
    cache: {
        cacheLocation: 'sessionStorage', // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
};
// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
exports.loginRequest = {
    scopes: [AUTH_SCOPE], // ['api://${AUTH_CLIENT}/fullAccess']
};
//# sourceMappingURL=config.js.map